import React, {createContext, useMemo} from 'react';
import {useConfig} from './ClientConfigContext';
import {ThemeProvider as MuiTheme} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import {default as muiTheme} from '../theme/theme';

const ThemeContext = createContext(null);

export const ThemeProvider = ({children}) => {
    const config = useConfig();

    const theme = useMemo(() => ({
        colors: config.theme,
        branding: config.branding
    }), [config]);

    React.useEffect(() => {
        // const root = document.documentElement;
        // root.style.setProperty('--primary-color', config.theme.primaryColor);
        // root.style.setProperty('--secondary-color', config.theme.secondaryColor);
        // root.style.setProperty('--background-color', config.theme.backgroundColor);
        // root.style.setProperty('--text-color', config.theme.textColor);

        document.title = config.branding.appName;

        const existingFavicons = document.querySelectorAll("link[rel*='icon']");
        existingFavicons.forEach(favicon => favicon.remove());

        const newFavicon = document.createElement('link');
        newFavicon.rel = 'icon';
        newFavicon.type = 'image/png';
        newFavicon.href = config.branding.favicon;

        document.head.appendChild(newFavicon);

        const cacheBuster = `?v=${new Date().getTime()}`;
        newFavicon.href = config.branding.favicon + cacheBuster;

    }, [config]);

    return (
        <ThemeContext.Provider value={theme}>
            <MuiTheme theme={muiTheme}>
                <CssBaseline />
                {children}
            </MuiTheme>
        </ThemeContext.Provider>
    );
};